

































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store';
import {
    IAllocation,
    IAllocationSearchParameters
} from '@/interfaces/allocation';
import SearchPanel from '@/components/allocations/search-panel.vue';
import ResultsPanel from '@/components/allocations/results-panel.vue';
import { excelExport } from '@/tools/excel-export';
import { acquireTokenWrapper } from '@/tools/session';
@Component({
    components: {
        SearchPanel,
        ResultsPanel,
    },
})
export default class Allocations extends Vue {
    public referenceText = "";
    private loading = false;
    async mounted(){
        await acquireTokenWrapper();
        await vxm.allocations.getFromToOptions();
        await vxm.allocations.getCarriersClients();
        await vxm.allocations.getLastRefreshDate();
    }
    
    get from(): string {
        return vxm.allocations.fromField;
    }   
    
    get to(): string {
        return vxm.allocations.toField;
    }

    get carrier(): string {
        return vxm.allocations.carrierField;
    }   
    
    get client(): string {
        return vxm.allocations.clientField;
    }
    
    get refreshDate(): string{
        return vxm.allocations.refreshDate;
    }

    get allocations(): IAllocation[] {
        return vxm.allocations.allocations;
    }

    get parameters(): IAllocationSearchParameters | null {
        return vxm.allocations.parameters;
    }

    get weekOffset(): any{
        return vxm.allocations.WeekOffset;
    }

    async search(searchParameters: IAllocationSearchParameters): Promise<void> {
        this.loading = true;

        await vxm.allocations.search(searchParameters);

        this.loading = false;
    }

    get splittedToOptions(){
        return this.to.split(',');
    }

    get splittedFromOptions(){
        return this.from.split(',');
    }


    get splittedCarrierOptions(){
        return this.carrier.split(',');
    }

    get splittedClientOptions(){
        return this.client.split(',');
    }

    async exportAllocations(): Promise<void> {
        if (!this.allocations) {
            // TODO: SHOW TOAST: cf other than bootstrap
            this.$bvToast.toast('No data to export', {
                autoHideDelay: 5000,
                variant: 'warning',
                appendToast: true,
                toaster: 'b-toaster-top-center',
                toastClass: 'rounded',
                headerClass: 'd-none',
            });
            return;
        }

        const fileName = this.getExportFileName();
        const sheetName = 'allocations';
        const columns = Object.keys(this.allocations[0]);
        const content = this.allocations;

        excelExport({
            fileName,
            sheetName,
            columns,
            content,
        });
        // TODO: SHOW TOAST: cf other than bootstrap
        this.$bvToast.toast('Data Exported', {
            autoHideDelay: 5000,
            variant: 'info',
            appendToast: true,
            toaster: 'b-toaster-top-center',
            toastClass: 'rounded',
            headerClass: 'd-none',
        });
    }
    copyAllocationReference(allocationReference: string) {
        this.referenceText = allocationReference;
        const inputElement = this.$refs.referenceCopyField as HTMLInputElement;
        inputElement.value = allocationReference;
        inputElement.type = 'text';
        var copyText = this.$refs.referenceCopyField as any;
        copyText.select();
        document.execCommand("copy");
        inputElement.type='hidden';

        // TODO: SHOW TOAST: cf other than bootstrap
        this.$bvToast.toast('Contract copied', {
            autoHideDelay: 5000,
            variant: 'info',
            appendToast: true,
            toaster: 'b-toaster-top-center',
            toastClass: 'rounded',
            headerClass: 'd-none',
            solid: true,
        });
    }

    private getExportFileName() {
        const now = new Date();
        const date = ('0' + now.getDate()).slice(-2);
        const month = ('0' + (now.getMonth() + 1)).slice(-2);
        const year = now.getFullYear();
        const hours = ('0' + now.getHours()).slice(-2);
        const minutes = ('0' + now.getMinutes()).slice(-2);
        const seconds = ('0' + now.getSeconds()).slice(-2);

        // get date & time in YYYYMMDDHHMMSS format
        const exportDateTime = `${year}${month}${date}${hours}${minutes}${seconds}`;

        const exportFileName = `allocations - ${exportDateTime}`;

        return exportFileName;
    }
}
